import React, {useEffect, useState} from 'react';
import ModalDialog from "../../../ui/ModalDialog/ModalDialog";
import {connect} from "react-redux";
import {showAddingAlert, showEditingAlert} from "../../../store/modalsSlice";
import PokemonPicker from "./PokemonPicker/PokemonPicker";
import QualitySlider from "./QualitySlider/QualitySlider";
import './AddAlert.css';
import IvSlider from "./IvSlider/IvSlider";
import PokemonList from "../../PokemonList/PokemonList";
import {parseCommaPokemonIdsIntoArray, pokemonQualityToName} from '../../../utils';
import pokedex from '../../../pokedex.json';
import {addAlert, editAlert, deleteAlert} from "../../../store/notificationsSlice";
import Button from "@material-ui/core/Button";
import {useHistory} from "react-router";
import {Switch} from "@material-ui/core";
import TimeRangeSlider from "./TimeRangeSlider/TimeRangeSlider";

const AddAlert = (props) => {
	const [minQuality, setMinQuality] = useState(0);
	const [minIv, setMinIv] = useState(0);
	const [paused, setPaused] = useState(false);
	const [pokemonList, setPokemonList] = useState([]);
	const [timeRange, setTimeRange] = useState([0, 1440]);
	const history = useHistory();

	useEffect(() => {
		if( props.addingAlert === null && props.editingAlert === null )
			return;

		if( props.editingAlert ) {
			setMinQuality(props.editingAlert.min_quality);
			setMinIv(props.editingAlert.min_iv);
			setTimeRange([props.editingAlert.start_time, props.editingAlert.end_time]);
			setPaused(!!props.editingAlert.paused);
			const list = parseCommaPokemonIdsIntoArray(props.editingAlert.pokemon_ids).map(p => { return {value: p, label: pokedex[p].name}; });
			setPokemonList(list);
		} else {
			setMinQuality(0);
			setMinIv(0);
			setPokemonList([]);
			setTimeRange([0,1440])
			setPaused(false);
		}
		// eslint-disable-next-line
	}, [props.addingAlert, props.editingAlert])

	const addAlert = () => {
		// let alert = null;
		if( props.editingAlert ) {
			props.editAlert(props.editingAlert, pokemonList, minQuality, minIv, timeRange[0], timeRange[1], paused);
		} else if( props.addingAlert ) {
			props.addAlert(props.addingAlert, pokemonList, minQuality, minIv, timeRange[0], timeRange[1], paused);
		}
		handleClose();
	};

	const handleClose = () => {
		props.showAddingAlert(false);
		props.showEditingAlert(false);
		history.push('/');
	};

	const onPokemonSelected = pokemon => {
		const newPokemonList = [...pokemonList];
		newPokemonList.push(pokemon);
		setPokemonList(newPokemonList);
	};

	const removePokemon = pokemon => {
		setPokemonList( [...pokemonList].filter(p => p.value !== pokemon.value) );
	};

	const deleteAlert = () => {
		if( !props.editingAlert )
			return;

		if( !window.confirm("Are you sure you want to delete this alert?") )
			return;

		props.deleteAlert(props.editingAlert.alert_id);
		handleClose();
	};

	const onPausedChanged = (event) => {
		setPaused(event.target.checked);
	};

	const onActiveTimesChanged = (event, newVal) => {
		setTimeRange(newVal);
	};

	const deleteButton = (<Button onClick={deleteAlert} color="secondary">Delete</Button>);

	return (
		<ModalDialog
			open={!!(props.addingAlert || props.editingAlert)}
			middleButton={deleteButton}
			handleClose={handleClose} handleSubmit={addAlert} title='Add Alert'
			style={{height: '100%'}}>

			<div className='ModalField'>
				<div className='ModalLabel'>What are you looking for?</div>
				<PokemonList list={pokemonList} default='All Pokemon' onClick={removePokemon} />
				<PokemonPicker onPokemonSelected={onPokemonSelected} />
			</div>

			<div className='ModalField'>
				<div className='ModalLabel'>Minimum Quality: {minQuality ? pokemonQualityToName(minQuality) : "Any"}</div>
				<div className='ModalSlider'>
					<QualitySlider value={minQuality} setValue={setMinQuality} />
				</div>
			</div>

			<div className='ModalField'>
				<div className='ModalLabel'>Minimum IV: {minIv ? minIv.toFixed(0) + "%+" : "None"}</div>
				<div className='ModalSlider'>
					<IvSlider value={minIv} setValue={setMinIv} />
				</div>
			</div>

			{paused ? null :
				<div className='ModalField'>
					<div className='ModalLabel'>Active Times:</div>
					<div className='ModalSlider'>
						<TimeRangeSlider value={timeRange} onChange={onActiveTimesChanged} />
					</div>
				</div>
			}

			<div className='ModalFieldOneLine'>
				<div className='ModalLabel'>Paused</div>
				<div className='ModalSlider'>
					<Switch checked={paused} onChange={onPausedChanged} inputProps={{ 'aria-label': 'primary checkbox' }} />
				</div>
			</div>
		</ModalDialog>
	);
};

const mapStateToProps = (state) => {
	return {
		addingAlert: state.modals.addingAlert,
		editingAlert: state.modals.editingAlert
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		showAddingAlert: (val) => dispatch(showAddingAlert(val)),
		showEditingAlert: (val) => dispatch(showEditingAlert(val)),
		addAlert: (zoneId, pokemonIds, minQuality, minIv, startTime, endTime, paused) => dispatch(addAlert(zoneId, pokemonIds, minQuality, minIv, startTime, endTime, paused)),
		editAlert: (alert, pokemonIds, minQuality, minIv, startTime, endTime, paused) => dispatch(editAlert(alert, pokemonIds, minQuality, minIv, startTime, endTime, paused)),
		deleteAlert: (alertId) => dispatch(deleteAlert(alertId))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAlert);